export default {
    "available_in_your_tariff": "Available in your tariff",
    "market": "Market",
    "market_of_apps": "Apps market",
    "most_popular_apps": "Most popular apps",
    "new_items": "New items",
    "recommended_apps": "Recommended apps",
    "setup": "Setup",
    "submit_an_application": "Submit an application",
    "your_application_was_submitted_our_manager_will_contact_you_soon": "Your application was submitted, our manager will contact you soon",
}
